import React from 'react';
import { useSearchParams } from 'react-router-dom';

const AuthError: React.FC = () => {
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message') || 'An authentication error occurred';

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      gap: '20px',
      padding: '20px',
      textAlign: 'center',
      backgroundColor: '#fbeae5'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        maxWidth: '500px'
      }}>
        <h1 style={{ color: '#bf0711', marginBottom: '20px' }}>
          Authentication Error
        </h1>
        <p style={{ color: '#637381', marginBottom: '30px' }}>
          {message}
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#f6f6f7',
              color: '#202223',
              border: '1px solid #c9cccf',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Go Back
          </button>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              padding: '10px 20px',
              backgroundColor: '#008060',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthError;
